import { useDocumentTitle } from '@/hooks';
import { PlatformScopeProvider } from '@/lib/platform-scope';
import { ConversationsPage } from '@/modules/conversations';

/**
 * O atendimento por WhatsApp de quem administra o SaaS - a mesma tela do
 * salao, so que apontada para a linha da propria plataforma em vez da de
 * um assinante.
 */
export function SaasVendaPage() {
  // Sobrescreve o titulo que a propria ConversationsPage define: aqui e
  // venda da plataforma, nao atendimento de um assinante.
  useDocumentTitle('Venda por WhatsApp');

  return (
    <PlatformScopeProvider prefix="/saas/venda">
      <ConversationsPage />
    </PlatformScopeProvider>
  );
}
